import { FC, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useAccess } from '../../hooks/useAccess'
import { INavItem } from './INav'
import SideBarNavLink from './SideBarNavLink'
import { icons } from '../../icons/IconSet'

const SideBarNav: FC = () => {
  const { getPageAccess } = useAccess()
  const { pathname } = useLocation()

  const filterNav = (nav: INavItem[]): INavItem[] =>
    nav.reduce((acc, item) => {
      if (item?.isNotAvailable) return acc
      if (!item?.children?.length) return [...acc, item]

      const children = filterNav(item.children)
      if (children?.length)
        return [
          ...acc,
          {
            ...item,
            children,
          },
        ]
      return acc
    }, [] as INavItem[])

  const nav: INavItem[] = filterNav([
    {
      name: `Imports`,
      icon: icons('archive', { width: '20px', opacity: '.7' }),
      to: '/imports',
      isNotAvailable: !getPageAccess('/imports'),
    },
    {
      name: `New Import`,
      icon: icons('archive-restore', { width: '20px', opacity: '.7' }),
      to: '/new-import',
      isNotAvailable: !getPageAccess('/new-import'),
    },
    {
      name: `Update`,
      icon: icons('calendar-clock', { width: '20px', opacity: '.7' }),
      to: '/tracking',
      isNotAvailable: !getPageAccess('/tracking'),
    },
    {
      name: `Settings`,
      icon: icons('settings', { width: '20px', opacity: '.7' }),
      to: '/settings',
      isNotAvailable: !getPageAccess('/settings'),
    },
  ])

  const [openedNavsIndxs, setOpenedNavsIndxs] = useState<Record<string, boolean>>(
    nav.reduce(
      (acc, { children }, i) => ({
        ...acc,
        [i]: !!children?.length,
      }),
      {} as Record<string, boolean>,
    ),
  )

  return (
    <nav className='flex flex-1 flex-col gap-2'>
      {nav.map(({ name, children, to, onClick, icon }, i) =>
        children?.length ? (
          <div
            key={`${name}-${i}`}
            className=' overflow-hidden'
          >
            <div
              className='text-text_pale px-2 flex justify-between cursor-pointer'
              tabIndex={-1}
              role='button'
              onClick={() =>
                setOpenedNavsIndxs((prevState) => ({
                  ...prevState,
                  [i]: !prevState?.[i],
                }))
              }
            >
              {name}
              {/* <RotateIcon isShown={openedNavsIndxs?.[i]}>
                {icons('chevron-down', { width: '16px' })}
              </RotateIcon> */}
            </div>
            <div
              className={`transition-all duration-300
              ${
                openedNavsIndxs?.[i]
                  ? 'opacity-100 translate-y-1 h-auto'
                  : 'opacity-0 -translate-y-0 h-0'
              }
            `}
            >
              {children.map((child, j) =>
                !child?.to || child?.disabled ? (
                  <div
                    key={`${child?.name}-${j}`}
                    className='block py-[6px] px-4 opacity-50'
                  >
                    {child?.name}
                  </div>
                ) : (
                  <SideBarNavLink
                    key={`${child?.to}-${child?.name}`}
                    to={child?.to}
                    // isCurrent={isCurrentPath(pathname, child?.to) && !children.find(({ to }) => to === child?.to) && pathname !== child?.to}
                    isCurrent={pathname === child?.to}
                  >
                    {child?.name || '-'}!!
                  </SideBarNavLink>
                ),
              )}
            </div>
          </div>
        ) : !to ? (
          name ? (
            <div className=''>{name}</div>
          ) : (
            <div
              key={`separator-${i}`}
              className='h-[1px] w-full border-b-[1px] border-border_color'
            />
          )
        ) : (
          <SideBarNavLink
            key={`${to}-${name}`}
            to={to}
            {...(icon ? { icon } : {})}
          >
            {name || '-'}
          </SideBarNavLink>
        ),
      )}
    </nav>
  )
}

export default SideBarNav
